(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/page-menu/assets/javascripts/page-menu.js') >= 0) return;  svs.modules.push('/components/accountservices/page-menu/assets/javascripts/page-menu.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  memo = _React.memo;
const isMobile = svs.core.detect.formfactor.mobile();
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const PageMenu = memo(_ref => {
  let title = _ref.title,
    backFunc = _ref.backFunc,
    backText = _ref.backText;
  const _svs$accountservices$ = svs.accountservices.pageMenu.useHeader(),
    setBackBtnFunc = _svs$accountservices$.setBackBtnFunc,
    setTitle = _svs$accountservices$.setTitle;
  const _useState = useState(isMobile || svs.core.detect.breakpoint.lessThan('sm')),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileFormFactor = _useState2[0],
    setIsMobileFormFactor = _useState2[1];
  const showBackButton = Boolean(backFunc);
  useEffect(() => {
    svs.core.detect.breakpoint.on('change', () => {
      if (svs.core.detect.breakpoint.greaterThan('xs')) {
        setIsMobileFormFactor(false);
      } else {
        setIsMobileFormFactor(true);
      }
    });
  }, []);
  useEffect(() => {
    const setTop = () => {
      if (isMobileFormFactor) {
        if (showBackButton) {
          setBackBtnFunc(backFunc);
        }
        setTitle(title);
      } else {
        if (showBackButton) {
          setBackBtnFunc(null);
        }
        setTitle(null);
      }
    };
    setTop();
  }, [isMobileFormFactor, title, setTitle, setBackBtnFunc, backFunc, showBackButton]);
  const handleBackButtonClick = e => {
    e.preventDefault();
    backFunc();
  };
  if (isMobileFormFactor) {
    return null;
  }
  return React.createElement("div", null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, null, React.createElement("div", {
    className: "bg-tur-200 f-400"
  }, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    xs: 12
  }, React.createElement(GridRow, null, React.createElement(GridCol, null, showBackButton && React.createElement("div", {
    className: "padding-h-1 page-menu-lineheight u-flex"
  }, React.createElement("a", {
    className: "page-menu-nav-item pointer u-text-reset",
    href: "/",
    onClick: handleBackButtonClick
  }, React.createElement("i", {
    className: "icon fc-black icon-200 icon-arrow-left"
  }), React.createElement("span", {
    className: "f-bold fc-black f-uppercase"
  }, ' ', backText)))), React.createElement(GridCol, {
    xs: "auto"
  }, React.createElement("div", {
    className: "f-bold f-uppercase page-menu-lineheight u-flex u-flex-justify-content-center"
  }, title)), React.createElement(GridCol, null)))))))));
});
PageMenu.defaultProps = {
  backFunc: null,
  backText: 'Tillbaka',
  title: ''
};
svs.accountservices.pageMenu.PageMenu = PageMenu;

 })(window);